(function (win, doc) {
    if (!win.addEventListener) return;
    function setFont() {
        const screenWidth = document.documentElement.clientWidth;
        let baseSize = 16; // 设计稿 1rem = 1px
        let designWidth = 1920; // 设计稿宽度
        let scale = screenWidth / designWidth;
        // if (screenWidth < 980){
        //     document.documentElement.style.fontSize =16 + "px";
        // }else {
            document.documentElement.style.fontSize = baseSize * scale + "px";
        // }

    }
    setFont();
    setTimeout(() => {
        setFont();
    }, 0);
    doc.addEventListener("DOMContentLoaded", setFont, false);
    win.addEventListener("resize", setFont, false);
    win.addEventListener("load", setFont, false);
})(window, document);
export{}